/**
 * Tipos e constantes relacionados aos objetos do pedido
 */

// Constantes para contrações
export const contractionOptions = ['0px', '1px', '2px', '3px', '4px'];
export const CONTRACTION_VARIABLE = 'VARIÁVEL';
export const CONTRACTION_VARIABLE_FILE = 'CV';

// Opções de entrega
export const deliveryOptions = ['Hoje', 'Amanhã', 'Noturna', 'URGENTE'];

// Interface para regras do produto
export interface ProductRules {
  nome_servico: string;
  descricao: string;
  horario_corte: string;
  largura_maxima_cm: number | null;  // ✅ null = sem limite (bypass)
  altura_maxima_cm: number | null;   // ✅ null = sem limite (bypass)
  use_pipeline?: boolean;
  use_pipeline_salvamento?: boolean;   // undefined/true = roda pipeline de preparação no salvamento; false = pula (abre ao vivo)
  valida_dimensao?: boolean;   // undefined/true = valida; false = pula (chave-mestra)
  valida_metragem?: boolean;   // undefined/true = valida; false = pula
  diretorio_base_interno?: string;
  diretorio_base_externo?: string;
  diretorio_base_exportpng?: string;    // ← NOVO: Diretório para exportação PNG
  diretorio_base_export_prod?: string;  // ← NOVO: Diretório para exportação produção
  exportacao: {
    formato: string;
    resolucao_dpi: number;
  };
}

// Interface para objetos do pedido
export interface OrderObject {
  id: string;
  nome: string;
  staticId: string; // ← NOVO: Identificador único do CorelDraw
  guid?: string;
  width: number;
  height: number;
  quantity: number;
  status: 'error' | 'warning' | 'success';
  message?: string;
  contraction?: string;
  totalArea?: number;
  include?: boolean; // se falso, objeto será ignorado nas exportações
  // NOVO: metadados de ordenação/posicionamento
  pageIndex?: number;           // índice da página (1-based, quando disponível)
  exportIndex?: number | null;  // ordem preferencial de exportação (1-based por página)
}

// Interface para objetos atualizados
export interface ObjetoAtualizado {
  staticId: string;
  guid?: string;
  nomeBase: string;
  multiplicador: number;
  contracao: string | null;
  usaContracaoVariavel: boolean;
} 